import { Button, Skeleton } from "@/components/ui";
import { LoaderCircle } from "lucide-react";
import type { RefObject } from "react";

export function ChatHistoryBoundary({
  sentinelRef,
  direction,
  loading,
  failed,
  onRetry,
}: {
  sentinelRef: RefObject<HTMLDivElement>;
  direction: "earlier" | "newer";
  loading: boolean;
  failed: boolean;
  onRetry: () => void;
}) {
  return (
    <div ref={sentinelRef} className="flex h-12 items-center justify-center">
      {loading ? (
        <span
          role="status"
          className="text-muted-foreground flex items-center gap-2 text-xs"
        >
          <LoaderCircle className="size-4 animate-spin" /> Loading {direction}{" "}
          messages
        </span>
      ) : failed ? (
        <Button type="button" variant="ghost" size="sm" onClick={onRetry}>
          Couldn’t load {direction} messages. Retry
        </Button>
      ) : null}
    </div>
  );
}

export function LoadingTimeline() {
  return (
    <div className="mx-auto flex w-full max-w-[60rem] flex-col gap-8 px-5 py-8 sm:px-8">
      <Skeleton className="ml-auto h-16 w-2/3 rounded-2xl" />
      <div className="space-y-3">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-11/12" />
        <Skeleton className="h-4 w-3/4" />
      </div>
    </div>
  );
}
